'use client';

import React, { FC, useMemo, useCallback } from 'react';
import { Container, modalStyle } from './SubmitAlert.styled';
import { reducerTypes } from '../../../store/Alert/types';
import { Modal } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks';
import { Box } from '@mui/material';
import Button from '../../../components/Button';
import { ModalContainer } from '../PriceBlock/styles';
import { FavoriteIcon } from '../../../icons';
import closeIcon from '../../../assets/images/svg/closeIcon.svg';
import Image from 'next/image';

type Props = {};

export const SubmitAlert: FC<Props> = () => {
  const dispatch = useAppDispatch();
  const { active, text, isPrompt, header, onApprove, onDecline, description, errorType } = useAppSelector(
    (st) => st.alert
  );
  const locale = useAppSelector((st) => st.locale);

  const messages = useMemo(() => {
    return {
      title_warning: locale['alert_title_warning'],
      title_thank_you: locale['alert_title_thank_you'],
      text: locale['alert_text'],
      button_yes: locale['alert_button_yes'],
      button_no: locale['alert_button_no'],
      button_okay: locale['alert_button_okay'],
    };
  }, [locale]);

  const closeAlert = useCallback(() => {
    onDecline && onDecline();
    dispatch({ type: reducerTypes.CLOSE_ALERT });
  }, [dispatch, onDecline]);

  function approveAlert() {
    onApprove && onApprove();
    dispatch({ type: reducerTypes.CLOSE_ALERT });
  }

  if (!active) return null;

  return (
    <Modal
      open={active}
      onClose={() => dispatch({ type: reducerTypes.CLOSE_ALERT })}
      aria-labelledby='modal-modal-title1'
      aria-describedby='modal-modal-description1'
    >
      <Box sx={modalStyle}>
        <ModalContainer>
          <Container>
            {!errorType && (
              <div className='submitted-header'>
                <span>{isPrompt ? `${messages.title_warning}` : header || `${messages.title_thank_you}`}</span>
              </div>
            )}
            <div className='submitted-info'>
              {errorType ? (
                <span>{text}</span>
              ) : (
                <span>
                  {text || `${messages.text}`} {text?.includes('wishlist') ? <FavoriteIcon size={15} /> : null}
                </span>
              )}
              {description ? <span>{description}</span> : null}
            </div>
            {isPrompt ? (
              <div className='buttons'>
                <Button
                  styleVariant='dark'
                  name={`${messages.button_yes}`}
                  onClick={approveAlert}
                  className='button-styled'
                >
                  Yes
                </Button>
                <Button
                  styleVariant='outline'
                  name={`${messages.button_no} `}
                  onClick={closeAlert}
                  className='button-styled'
                >
                  No
                </Button>
              </div>
            ) : (
              <>
                <div onClick={closeAlert} className='close-icon' style={{ top: '0px', right: '0px' }}>
                  <Image src={closeIcon} alt='X' />
                </div>
              </>
            )}
          </Container>
        </ModalContainer>
      </Box>
    </Modal>
  );
};

export default SubmitAlert;
